<template>
  <div class="box">
    <div ref="chart" />
    <div class="lenged">
      <router-link :to="{name: 'trackList', query: item.query}" v-for="(item, key) in chartData" :key="key">
        <span class="marker" :style="{backgroundColor: item.color}" />
        <span class="text">{{ item.label }}</span>
        <span class="count">{{ item.value | displayCount }} 首</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import { Chart } from '@/utils/g2'
// import { formatHotIndex } from '@/filters'

const colors = ['#7285FA', '#67E8C9']

export default {
  name: 'BaseCpChart',

  props: {
    config: {
      type: Object,
      required: true
    },

    data: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      chartData: [],
    }
  },

  computed: {
    chartEl() {
      return this.$refs.chart
    },
  },

  watch: {
    data() {
      const result = []

      const count = Object.keys(this.config).reduce((prev, cur, index) => {
        const portion = this.data[`${cur}Play`]
        result.push({
          ...this.config[cur],
          value: this.data[cur],
          color: colors[index],
          portion
        })
        return prev + portion
      }, 0)

      this.chartData = result.map(val => {
        const percent = +(val.portion / count)
        const displayPercent = `${(percent * 100).toFixed(2)}%`
        const tmePercent = val.portion
        return {
          ...val,
          percent,
          tmePercent,
          displayPercent
        }
      })
      this.renderChart()
    }
  },

  beforeDestroy() {
    this.chart && this.chart.destroy()
  },

  methods: {

    renderChart() {
      this.chart = new Chart({
        container: this.chartEl,
        autoFit: true,
        height: 220,
        width: 240,
        padding: [10, 0, 40, 0],
        animate: true
      })

      this.chart.coordinate('theta', {
        radius: 0.9,
        innerRadius: 0.5
      })

      this.chart
        .tooltip({
          showTitle: false,
          useHtml: true,
          domStyles: {
            'g2-tooltip': {
              width: '220px',
              padding: '8px 12px'
            },
            'g2-tooltip-title': {
              display: 'none'
            },
            'g2-tooltip-name': {
              margin: '5px 0',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis'
            },
            'g2-tooltip-value': {
              float: 'unset',
              display: 'inline',
              marginLeft: '5px'
            }
          },
          itemTpl: '<li style="text-align:left;line-height:1.5">' +
            '<span style="background-color:{color};width:8px;height:8px;border-radius:50%;display:inline-block;margin-right:8px;"></span>{name}<br>' +
            '<span style="background-color:{color};width:8px;height:8px;border-radius:50%;display:inline-block;margin-right:8px;"></span>{value}' +
          '</li>'
        })

      this.chart
        .interval()
        .adjust('stack')
        .tooltip('displayPercent*tmePercent', (displayPercent, tmePercent) => {
          return {
            name: `占厂牌播放份额:  ${displayPercent}`,
            value: `TME播放指数:  ${tmePercent}`
          }
        })
        .position('percent')
        .color('label', colors)
        .style({
          lineWidth: 1,
          stroke: '#fff'
        })

      this.chart.legend(false)

      this.chart.data(this.chartData)

      this.chart.render()
    }
  },
}
</script>

<style lang="scss" scoped>
.box {
  height: 300px;
}

.lenged {
  a {
    line-height: 25px;
    color: #002444;
    font-size: 14px;
    display: block;
    text-align: left;
    padding-left: 20px;
  }

  .text {
    margin-left: 10px;
    width: 130px;
    font-size: 14px;
    color: #1672fa;
    display: inline-block;
    text-decoration: underline;
  }

  .marker {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 6px;
    vertical-align: middle;
  }

  .count {
    white-space: nowrap;
    display: inline-block;
    width: 70px;
    text-align: right;
  }
}
</style>
